import type { ArticleData } from '../entities/article';

export const getAuthorName = (articleData: ArticleData): string => {
  if (articleData?.author?.firstname && articleData?.author?.lastname) {
    return `${articleData.author.firstname} ${articleData.author.lastname}`;
  }
  return articleData?.author?.name || articleData?.name || '';
};

export const authorTypeGenerator = (
  authorType = 'Benzinga Staff Writer',
  showAdvertiserDisclosure: boolean,
  contentType: string,
): string => {
  if (showAdvertiserDisclosure) {
    //authorType = 'Benzinga Partner';
  }
  if (contentType !== 'story') {
    //   authorType = 'Contributor';
  }

  return authorType;
};
